const macDetail = {
	state : {
		machineId: '',
		machineCode: '',
		machineTypeId: '',
		updateGoodsParam: null,
		ctrlEnabled: null,
		lightCtrlEnabled: null,
		channelTest: null,
		updateChannelCapacity: null,
		onlyScanGoodsCode: false
	},

	mutations: {
		GET_MAC: (state,mac) => {
			state.mac = mac;
		}
	}
}

export default macDetail;


// WEBPACK FOOTER //
// ./src/store/modules/macDetail.js